import { useTranslate } from '@tolgee/react';
import Empty from 'components/Empty';
import { Button } from 'antd';
import { isArray, isEmpty } from 'lodash-es';

interface ConversationListEmptyProps {
  onRefresh: () => void;
  onClearFilterAndRefresh: () => void;
  queryConversationListParams: ApiConversation.ConversationListAdvanceParams;
}

export const ConversationListEmpty = (props: ConversationListEmptyProps) => {
  const { onRefresh, onClearFilterAndRefresh, queryConversationListParams } = props;
  const { t } = useTranslate();

  const hasFilter = Object.values(queryConversationListParams).some((v) => {
    if (isArray(v)) {
      return v.length > 0;
    }
    return !isEmpty(v);
  });

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2">
      <div className="flex items-center gap-2">
        <Empty
          imageWidth={80}
          imageHeight={80}
          description={
            <div className="flex flex-col items-center">
              {hasFilter ? (
                <>
                  <span>{t('暂无符合筛选条件的数据')}</span>
                  <Button type="link" onClick={onClearFilterAndRefresh}>
                    {t('清除筛选')}
                  </Button>
                </>
              ) : (
                <>
                  {t('storeSelector.暂无数据')}
                  <Button type="link" onClick={onRefresh}>
                    {t('convList.refresh')}
                  </Button>
                </>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};
